import { render, staticRenderFns } from "./NewsCardPhone.vue?vue&type=template&id=ebc4baf2&"
import script from "./NewsCardPhone.vue?vue&type=script&lang=js&"
export * from "./NewsCardPhone.vue?vue&type=script&lang=js&"
import style0 from "./NewsCardPhone.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports